import type { DealForwardData } from '@src/types/OTC';
import { useCurrenciesContext } from '@talos/kyoko';
import { InspectorNumberDisplay } from './InspectorNumberDisplay';

interface PriceDisplayProps {
  instrumentData: DealForwardData;
}

export const ForwardPriceDisplay = ({ instrumentData }: PriceDisplayProps) => {
  const value = instrumentData.DealInfo.ForwardPrice || '';
  const currency = instrumentData.DealInfo.forwardPriceCurrency;
  const { currenciesBySymbol } = useCurrenciesContext();
  const currencyInfo = currency ? currenciesBySymbol.get(currency) : undefined;
  return (
    <InspectorNumberDisplay
      value={value}
      currency={currencyInfo?.Symbol ?? currency}
      increment={currencyInfo?.DefaultIncrement}
    />
  );
};
